export enum RecorderStatus {
  media_aborted = "media_aborted",
  permission_denied = "permission_denied",
  no_specified_media_found = "no_specified_media_found",
  media_in_use = "media_in_use",
  invalid_media_constraints = "invalid_media_constraints",
  no_constraints = "no_constraints",
  recorder_error = "recorder_error",
  idle = "idle",
  acquiring_media = "acquiring_media",
  delayed_start = "delayed_start",
  recording = "recording",
  stopping = "stopping",
  stopped = "stopped",
  paused = "paused",
}
